import React from "react";
import { StyleSheet, Text, TextInput } from "react-native";
import Icons from "@expo/vector-icons/MaterialCommunityIcons";
import { View } from "../shared/Themed";
import { ReadOnlyProps } from "../../utils/templates";
import { useAppTheme } from "../../hooks/useAppTheme";
import type { ThemeColors } from "../../utils/constants/colors";

interface Props {
  required?: boolean;
  title: string;
  placeholder?: string;
  value: string;
  width: string;
  editable?: boolean;
  blurOnSubmit?: boolean;
  isMultiline?: boolean;
  refInput?: any;
  height?: number;
  isTextEntrySecure?: boolean;
  showSoftInputOnFocus?: boolean;
  setChangeText: (event: any) => void;
  handleOnSubmitEditing?: (event: any) => void;
}

export const TextInputControl: React.FC<ReadOnlyProps<Props>> = ({
  required = false,
  title,
  placeholder = "",
  value,
  width,
  editable = true,
  blurOnSubmit = true,
  isMultiline = false,
  isTextEntrySecure = false,
  showSoftInputOnFocus = true,
  refInput,
  height = 35,
  setChangeText,
  handleOnSubmitEditing,
}: ReadOnlyProps<Props>) => {
  const { colors } = useAppTheme();
  const styles = createStyles(colors);
  return (
    <View style={{ flexDirection: "column", width: width as any, marginTop: 14 }}>
      <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 6 }}>
        <Text style={styles.label}>
          {title}
        </Text>
        {required && <Icons name="star" size={8} color="#EF4444" style={{ marginLeft: 4 }} />}
      </View>
      <View>
        <TextInput
          style={[styles.input, { height: height || 44 }]}
          ref={refInput}
          onChangeText={setChangeText}
          placeholder={placeholder}
          placeholderTextColor={colors.textMuted}
          value={value}
          multiline={isMultiline}
          editable={editable}
          blurOnSubmit={blurOnSubmit}
          autoFocus={false}
          onSubmitEditing={handleOnSubmitEditing}
          secureTextEntry={isTextEntrySecure}
          showSoftInputOnFocus={showSoftInputOnFocus}
        />
      </View>
    </View>
  );
};

function createStyles(colors: ThemeColors) {
  return StyleSheet.create({
    container: {
      alignSelf: "flex-start",
    },
    label: {
      fontSize: 13,
      fontWeight: "600",
      color: colors.textSecondary,
      textAlign: "left",
    },
    input: {
      backgroundColor: colors.background,
      borderWidth: 1,
      borderRadius: 8,
      paddingHorizontal: 12,
      fontSize: 14,
      borderColor: colors.textMuted,
      color: colors.text,
    },
  });
}
